import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <div className="max-w-[820px] mx-auto px-4 md:px-8 pt-10 md:pt-16 pb-16">
      <div className="flex items-center gap-2 text-sm text-text-muted mb-4">
        <Link to="/" className="text-text-secondary hover:text-accent transition-colors">Home</Link>
        <span>/</span>
        <span>Privacy</span>
      </div>

      <h1 className="font-display text-2xl md:text-[2.5rem] font-bold tracking-tight mb-2">Privacy policy</h1>
      <p className="text-text-muted text-sm mb-8">Last updated: 20 July 2026</p>

      <div className="article-body">
        <p>
          MarineLink Co NZ ("MarineLink", "we", "us") operates marinelink.co.nz, a directory of New Zealand
          marine businesses. This policy explains what information we collect, why, and what you can do about it.
          We handle personal information in accordance with the New Zealand Privacy Act 2020.
        </p>

        <h2>What we collect</h2>

        <p>
          <strong>Business listing information.</strong> When a business lists with us, we collect the details
          that appear on the listing - business name, contact person, phone, email, website, location, services
          and description. Much of this is published publicly as part of the directory; that's the point of it.
        </p>

        <p>
          <strong>Account information.</strong> If you sign in to manage a listing, we store your email address
          and sign-in activity so you can access your account securely.
        </p>

        <p>
          <strong>Enquiries.</strong> If you contact us by email, we keep that correspondence so we can respond
          and keep a record of what was agreed.
        </p>

        <p>
          <strong>Usage data.</strong> We use Google Analytics 4 to understand how the site is used - pages
          visited, approximate region, device type and how people arrived. This is aggregated and we don't use
          it to identify individuals.
        </p>

        <h2>What we don't do</h2>

        <p>
          We don't sell your personal information. We don't share listing contact details with third parties
          beyond what the listing itself publishes. We don't send marketing email you haven't asked for.
        </p>

        <h2>Cookies</h2>

        <p>
          We use a small number of cookies: strictly functional ones (your theme preference and sign-in session)
          and analytics cookies from Google Analytics. You can block cookies in your browser; the directory will
          still work, though sign-in features won't.
        </p>

        <h2>Payments</h2>

        <p>
          Payments for premium listings are processed by Stripe. We never see or store your full card details -
          those go directly to Stripe, whose own privacy policy applies.
        </p>

        <h2>Your rights</h2>

        <p>
          Under the Privacy Act 2020 you can ask to see the personal information we hold about you, and ask us
          to correct it. Business owners can update or remove their listing at any time by signing in or
          contacting us.
        </p>

        <h2>Contact</h2>

        <p>
          Privacy questions, access requests or corrections:{' '}
          <a href="mailto:info@marinelink.co.nz" className="text-accent hover:underline">info@marinelink.co.nz</a>.
          If you're not satisfied with our response, you can complain to the Office of the Privacy Commissioner
          (privacy.org.nz).
        </p>
      </div>
    </div>
  );
}
